import { Tooltip } from "@design-system/Tooltip/Tooltip";
import type { ClientsWorkOverviewWorkRow } from "../clientsWorkOverviewViewConfig";
import { getWorkOverdueLabel } from "../workOverdue";
import { formatWorkDate } from "./WorkCloseDateCell";
import { makeEditableDateCell } from "./WorkEditableDateCell";

interface WorkDeliveryDateWithOverdueProps {
    row: Pick<
        ClientsWorkOverviewWorkRow,
        "isFinished" | "cancelledAt" | "workDeliveryDate"
    >;
}

/** Work end; when open work is past it, "4 days overdue" shows on hover. */
export const WorkDeliveryDateWithOverdue = ({
    row,
}: Readonly<WorkDeliveryDateWithOverdueProps>) => {
    if (!row.workDeliveryDate) {
        return null;
    }
    const date = formatWorkDate(row.workDeliveryDate);
    const overdueLabel = getWorkOverdueLabel(row);
    if (overdueLabel === null) {
        return date;
    }
    return (
        <Tooltip content={overdueLabel}>
            <span>{date}</span>
        </Tooltip>
    );
};

/** The Work end column's cell. */
export const WorkDeliveryDateCell = makeEditableDateCell("workDeliveryDate");
WorkDeliveryDateCell.displayName = "WorkDeliveryDateCell";
